/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://eec10xou40.execute-api.us-east-1.amazonaws.com/prodfive",
            "region": "us-east-1"
        },
        {
            "name": "restapi",
            "endpoint": "https://fovrlxsa31.execute-api.us-east-1.amazonaws.com/prodfive",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://xidmq7gmdjaldj3b2ciofp5uhy.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-1:f900fb0a-c5ca-4d4a-849e-d38ca1a58773",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_slrxTMIn6",
    "aws_user_pools_web_client_id": "n34jk8c7tm9e5kqbdc87dbib1",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_content_delivery_bucket": "babtl-20240101215828-hostingbucket-prodfive",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://dc12sgdlkdt6v.cloudfront.net"
};


export default awsmobile;
